<template>
  <div id="app" style="height: 100%; font-family: '微软雅黑'">
    <div class="fileToDownImg_div">
      <span
        class="glyphicon glyphicon-file"
        style="font-size: 20px; margin-top: 5px"
      ></span>
    </div>
    <div class="head">
      <!--  header上半部分-->
      <div class="head_top">
        <div class="head_top_content">
          <div class="head_top_left">
            <router-link :to="'/gsgg'">
              <img
                src="/img/login/white-logo1.png"
                alt=""
                style="height: 38px; margin-left: 24px"
              />
            </router-link>
          </div>
          <div class="head_top_right">
            <div class="head_top_item">
              <Select
                class="dbselect"
                v-model="model11"
                @on-change="toDatabase"
                filterable
                placeholder="搜索库"
                prefix="md-search"
              >
                <Option
                  v-for="item in dataBase"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </div>

            <div
              class="head_top_item item_downloadlist"
              @click="showModaldownloadList"
            >
              <i class="iconfont icon-xiazai2"></i>
            </div>
            <span class="head_top_line"></span>
            <div class="head_top_item">
              <Dropdown trigger="click" style="margin-left: 10px">
                <a href="javascript:void(0)">
                  {{ this.$store.state.userInfo.UserName }}账号
                  <Icon type="ios-arrow-down"></Icon>
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem>
                    <div>{{ this.$store.state.userInfo.UserName }}账号</div>
                  </DropdownItem>
                  <DropdownItem>
                    <!-- <div @click="showSupplyDown" v-if="this.$store.state.userInfo.tel!=''"> -->
                    <!-- <div @click="Personal_Center" v-if="this.$store.state.userInfo.tel!=''">
                    <Icon type="ios-person-outline" style="margin-right: 12px"/>
                    个人中心
                  </div> -->
                  </DropdownItem>
                  <DropdownItem>
                    <div
                      href="#contact"
                      data-toggle="modal"
                      data-target=".contactUs"
                    >
                      <Icon
                        type="ios-headset-outline"
                        style="margin-right: 12px"
                      />
                      联系我们
                    </div>
                  </DropdownItem>
                  <DropdownItem divided>
                    <div title="安全退出" v-on:click="deleteFlagCookie">
                      <Icon type="ios-log-out" style="margin-right: 12px" />
                      退出登录
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <span class="head_top_line"></span>
            <a style="color: white" @click="Personal_Center">
              <Icon
                type="ios-person-outline"
                style="margin-right: 2px"
              />个人中心
            </a>
            <i
              class="el-icon-video-play"
              @click="playVideo"
              style="
                font-size: 14px;
                color: white;
                cursor: pointer;
                height: 60px;
                margin-left: 20px;
              "
            >
              操作视频</i
            >
            <i
              class="el-icon-download"
              @click="DownLoadClient"
              style="
                font-size: 14px;
                color: white;
                cursor: pointer;
                height: 60px;
                margin-left: 20px;
              "
            >
              下载客户端</i
            >
            <el-dialog
              title=""
              :visible.sync="dialogVisible"
              width="80%"
              destroy-on-close
            >
              <video
                controls
                style="width: 100%; height: 100%; padding-top: 10px"
                controlsList="nodownload"
                src="https://jinghe-picture.oss-cn-shanghai.aliyuncs.com/aitextsClient/%E7%88%B1%E6%96%87%E6%9C%AC%E6%93%8D%E4%BD%9C%E8%AE%B2%E8%A7%A3%E8%A7%86%E9%A2%91.mp4"
              ></video>
            </el-dialog>
          </div>
        </div>
      </div>
      <!--  header下半部分-->
      <div class="head_center">
        <div class="navigation">
          <div class="navigation_menu">
            <div class="navigation_bottom_color_div"></div>
            <!-- <router-link to="/index" style="color:#44444F;text-decoration:none;">
              <div class="oneNavItem_div">
                <h4><i class="iconfont icon-home" style="top: 0.5px"></i>首页</h4>
              </div>
            </router-link> -->
            <router-link
              to="/gsgg"
              style="color: #44444f; text-decoration: none"
            >
              <div class="oneNavItem_div">
                <h4><i class="iconfont icon-gongsigonggao"></i>公司公告</h4>
              </div>
            </router-link>
            <router-link
              to="/xwbd"
              style="color: #44444f; text-decoration: none"
            >
              <div class="oneNavItem_div">
                <h4><i class="iconfont icon-xinwenbaodao"></i>新闻报道</h4>
              </div>
            </router-link>
            <router-link
              to="/yjbg"
              style="color: #44444f; text-decoration: none"
            >
              <div class="oneNavItem_div">
                <h4><i class="iconfont icon-yanjiubaogao"></i>研究报告</h4>
              </div>
            </router-link>
            <router-link
              to="/gsjg"
              style="color: #44444f; text-decoration: none"
            >
              <div class="oneNavItem_div">
                <h4><i class="iconfont icon-gongsixinxi"></i>公司研究</h4>
              </div>
            </router-link>
            <router-link
              to="/qtwb"
              style="color: #44444f; text-decoration: none"
            >
              <div class="oneNavItem_div">
                <h4>
                  <i class="iconfont icon-ico_zonghexinxi_xuanzhong"></i
                  >综合文本
                </h4>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom_div">
      <div class="right_div">
        <!--    路由：_type-->
        <router-view
          @showHistory="showHistoryModel"
          @showHistoryModel="showHistoryModel"
        ></router-view>
        <!--    footer上半部分-->
        <div class="footertop">
          <div class="container">
            <div class="row">
              <div class="col-lg-3 col-md-6" id="footerlogo">
                <div class="single-widget">
                  <router-link to="/"
                    ><img src="/img/login/link.png"
                  /></router-link>
                </div>
                <div style="margin-top: -160px; margin-left: 55px">
                  <p style="font-size: 16px; color: #cccccc">
                    ©2014-2024 by Shanghai Jing He All Rights Reserved
                  </p>
                  <p>
                    <a
                      href="https://beian.miit.gov.cn/"
                      target="_blank"
                      style="color: #cccccc"
                      >沪ICP备15037428号-16</a
                    >
                  </p>
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="single-widget">
                  <h3>系列</h3>
                  <ul class="additional-link">
                    <li>
                      <a @click="goToPathAndTop('/gsgg')">公司公告</a>
                    </li>
                    <li>
                      <a @click="goToPathAndTop('/xwbd')">新闻报道</a>
                    </li>
                    <li>
                      <a @click="goToPathAndTop('/yjbg')">研究报告</a>
                    </li>
                    <li>
                      <a @click="goToPathAndTop('/gsjg')">公司研究</a>
                    </li>
                    <li>
                      <a @click="goToPathAndTop('/qtwb')">综合文本</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="single-widget">
                  <h3>联系我们</h3>
                  <ul class="address">
                    <li>
                      <Icon type="ios-call" />
                      +86 021-66181082
                    </li>
                    <li>
                      <Icon type="ios-mail" />
                      dataservice@aitexts.com
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="single-widget">
                  <h3>支持</h3>
                  <ul class="additional-link">
                    <li>
                      <a @click="modalaboutUs = true" id="aboutusbtn"
                        >关于我们</a
                      >
                    </li>
                    <li>
                      <a
                        href="#contact"
                        data-toggle="modal"
                        data-target=".contactUs"
                        id="contactusbtn"
                        >联系我们</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--    footer下半部分-->
        <div class="aitexts-footer">
          <div class="footer-content content-wh">
            <div class="footer-el">
              <!--                            <div class="footer-logo" style="margin-left: 152px;">-->
              <!--                                <router-link to="/"><img src="/img/login/link.png" style="width:150px;height:150px;margin: 13px 5px 0 5px;" /></router-link>-->
              <!--                            </div>-->
              <div class="footer-addr">
                <!--                                <div class="addr">Copyright © 2014-2020 Shanghai Jing He</div>-->
                <!--                                <div class="addr">Tel：(+86)021-66181082 E-mail：dataservice@aitexts.com</div>-->
                <!--                                <div class="addr">All Rights Reserved</div>-->
                <div class="addr">
                  ©2014-2025 by
                  <a href="http://www.efindata.com/">Shanghai Jing He</a> All
                  Rights Reserved
                </div>
              </div>
              <!-- <div class="footer-code" style="margin-right: 44px;"><img src="/img/login/aitexts-code.jpg"></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--黑色遮罩-->
    <div
      id="backDropDiv"
      class="modal-backdrop in"
      style="background-color: rgba(0, 0, 0, 1); display: none"
    ></div>

    <!--温馨提示模态框 试用账号只能查看2015年以来的数据/匿名登录只能查看部分样本数据-->
    <div
      class="modal fade"
      id="warningModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="top: 35%"
      data-backdrop="static"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div
            class="modal-header"
            style="border: 0px; padding: 10px; background-color: #3c84be"
          >
            <button
              id="closeButton"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
              v-on:click="clearBackDrop"
            >
              <span class="glyphicon glyphicon-remove"></span>
            </button>
            <h4 class="modal-title" id="myModalLabel">温馨提示</h4>
          </div>
          <div class="modal-body" style="font-size: 16px">
            <div v-if="roleId == '1'">
              <span
                >　　试用账号只能查看2015年以来的数据。<br />　　如需更多数据，请您联系人工客服购买正式账号！</span
              ><br />
              <span style="color: red">　　{{ residueTime }}</span>
              <span> 秒后关闭……</span>
            </div>
            <div v-if="roleId == '0'">
              <span
                >匿名登录只能查看部分样本数据。<br />如需更多数据，请您联系人工客服申请免费试用账号或购买正式账号！</span
              ><br />
              <span></span>
              <span style="color: red">{{ residueTime }}</span>
              <span> 秒后关闭……</span>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal -->
    </div>
    <!--关于我们模态框-->
    <Modal v-model="modalaboutUs" fullscreen footer-hide class="modalaboutus">
      <a slot="close"><i class="ivu-icon ivu-icon-ios-close"></i></a>
      <div>
        <section class="block overlay">
          <div class="fixed-bg bg1"></div>
          <div class="container">
            <div class="section-title">
              <h2 class="h-title">爱文本(AItexts)智能文本分析系统</h2>
            </div>
            <!--section-title end-->
            <div class="services">
              <div class="row">
                <div class="col-lg-6">
                  <div class="service-col">
                    <h2>01<span>.</span></h2>
                    <h4>我们的愿景</h4>
                    <p>致力于成为领先的智能文本分析应用平台</p>
                  </div>
                  <!--service-col end-->
                </div>
                <div class="col-lg-6">
                  <div class="smpl-txt">
                    <h4>关于我们</h4>
                    <p>
                      “爱文本（AItexts）智能文本分析系统”是由知名人工智能团队开发，上海经禾信息技术有限公司负责运维和市场推广的新一代智能文本分析产品。爱文本智能文本分析系统专注于为广大科研人员和业界投资人士提供精确、高效和便捷的文本分析工具和服务，致力于帮助客户深度挖掘文本信息，获取包括诸如文本词频、语调情感、文本可读性和文本相似度等文本分析结果，实现科研和投资的智慧化。
                    </p>
                    <p>
                      爱文本智能文本分析系统在文本获取与清洗、文本语义分析、文本信息智能化呈现上具有多年的业务实践和技术积淀，凭借领先的文本数字化和智能化产品，打造服务于科研、投资的多维场景解决方案，为客户创造价值。
                    </p>
                    <p>
                      爱文本智能文本分析系统将继续秉承开放合作、价值创造的原则，积极协同科学研究和投资实务等各领域的合作伙伴，为用户量身打造高价值、高水平的文本分析应用软件产品和解决方案。
                    </p>
                  </div>
                  <!--smpl-txt end-->
                </div>
              </div>
              <div class="row" style="position: relative; top: -170px">
                <div class="col-lg-6">
                  <div class="service-col">
                    <h2>02<span>.</span></h2>
                    <h4>我们的使命</h4>
                    <p>
                      汇聚海量文本，深度挖掘信息，助力用户实现智慧研究和投资
                    </p>
                  </div>
                  <!--service-col end-->
                </div>
                <div class="col">
                  <div class="service-col" style="max-width: 1000px"></div>
                  <!--service-col end-->
                </div>
              </div>
            </div>
            <!--services end-->
          </div>
        </section>
      </div>
      <div slot="footer"></div>
    </Modal>
    <iframe
      id="MsgBoardIframe"
      name="MsgBoardIframe"
      style="display: none"
    ></iframe>
    <!--联系我们模态框-->
    <div
      class="modal fade contactUs mirror"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      style="color: initial; font-family: '微软雅黑'; font-size: 16px"
      data-backdrop="static"
      keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <form
          action="/api/submitAdvice.do"
          target="MsgBoardIframe"
          method="post"
          id="submitAdviceForm"
        >
          <div class="modal-content contact">
            <div class="modal-header">
              <button
                id="closeContactUsModalBtn"
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h3 class="">
                Contact us | <span style="font-size: 95%">联系我们</span>
              </h3>
              <p class="modal-title"></p>
            </div>
            <div class="modal-body">
              <div class="contacttxt">
                <p style="padding-bottom: 5px">
                  尊敬的先生/女士，欢迎您关注爱文本（AI
                  texts）智能文本分析系统。
                </p>
                <p>
                  您可以在下方文本框中填写任何对于我们产品的问题或需求建议，我们将在<b>一个工作日内</b>回复您；或者您也可以直接联络我们，获得更多信息！
                </p>
              </div>
              <div>
                <div class="form-group" id="comment-form-author">
                  <label for="name">称谓</label>
                  <input
                    type="text"
                    style="
                      border: 1px solid rgb(76, 131, 188);
                      padding: 5px 10px 5px 35px;
                    "
                    class="form-control"
                    name="name"
                    placeholder="name"
                  />
                </div>
                <div class="form-group" id="comment-form-phone">
                  <label for="phone">电话</label>
                  <input
                    type="text"
                    style="
                      border: 1px solid rgb(76, 131, 188);
                      padding: 5px 10px 5px 35px;
                    "
                    class="form-control"
                    name="phone"
                    placeholder="phone"
                  />
                </div>
                <div class="form-group" id="comment-form-school">
                  <label for="school">学校</label>
                  <input
                    type="text"
                    style="
                      border: 1px solid rgb(76, 131, 188);
                      padding: 5px 10px 5px 35px;
                    "
                    class="form-control"
                    name="school"
                    placeholder="school"
                  />
                </div>
                <div class="form-group" id="comment-form-email">
                  <label for="email">E-mail</label>
                  <input
                    type="email"
                    style="
                      border: 1px solid rgb(76, 131, 188);
                      padding: 5px 10px 5px 35px;
                    "
                    class="form-control"
                    name="email"
                    placeholder="e-mail"
                  />
                </div>
                <div class="form-group">
                  <label for="message">留言</label>
                  <textarea
                    class="form-control"
                    rows="3"
                    name="message"
                    placeholder="please enter your message"
                  ></textarea>
                </div>
                <div>
                  <button type="submit" id="contactbtn" class="btn btn-primary">
                    Submit | 提交
                  </button>
                </div>
              </div>
              <hr style="width: 100%" />
              <div class="contactinf">
                <h4 style="color: black">Contact information | 联系信息</h4>
                <p>用户经理：刘经斌</p>
                <p>售前咨询、需求对接</p>
                <p>电话：13391311631</p>
                <p>邮箱：dataservice@aitexts.com</p>
                <img
                  src="/img/login/wechat_QRCode_left.png"
                  class="img_class"
                  style="width: 100px; height: 100px"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!--下载列表模态框-->
    <Modal v-model="modaldownloadList" width="1000" class="modaldownload">
      <div slot="header" class="modaldownload_header">
        <div class="modaldownload_header_inner">
          <i
            class="iconfont icon-gaiyao"
            style="
              font-size: 24px !important;
              vertical-align: middle;
              position: relative;
              top: -1px;
            "
          ></i>
          下载列表
        </div>
      </div>
      <div class="downloadlist_table_div scrollbars">
        <table
          class="downloadlist_table stickythead hoverline"
          cellspacing="0"
          cellpadding="0"
        >
          <thead class="downloadlist_thead">
            <tr>
              <th>序号</th>
              <th>下载时间</th>
              <th>内容</th>
              <th>进度</th>
              <th>情况</th>
              <th>下载</th>
            </tr>
          </thead>
          <tbody class="downloadlist_tbody">
            <!--          空状态-->
            <td
              v-show="showHistoryTr"
              colspan="6"
              style="padding-top: 66px"
              class="kzt"
            >
              <i class="iconfont icon-kongzhuangtai"></i>
              <p>当前暂无下载任务</p>
            </td>

            <!--      1：完整 正在压缩/正在压缩/下载不可点 -->
            <!--      2：演示用 压缩完成/未下载/下载可点 -->
            <!--      3：演示用 压缩完成/已下载/下载可点-->
            <!--1-->
            <tr v-for="(item, index) in getSortList" :key="item.md5">
              <td style="width: 5%">
                {{ index + 1 }}
              </td>
              <td style="width: 20%">
                {{ item.start }}
              </td>
              <td
                style="
                  width: 40%;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ item.condition }}
              </td>
              <td style="width: 10%">
                <div v-if="item.process !== '已完成'" style="color: #4184f3">
                  <Icon type="ios-loading" class="ani-loading" />
                  {{ item.process }}
                </div>
                <div v-else style="color: #19be6b">
                  <Icon type="md-checkmark" class="ani-check" />
                  已完成
                </div>
              </td>
              <td style="width: 15%">
                <div v-if="item.process !== '已完成'" style="color: #4184f3">
                  {{ item.percentage }}%
                </div>
                <div v-else-if="item.isDownload" style="color: #4184f3">
                  已下载
                </div>
                <div v-else style="color: #19be6b">可下载</div>
              </td>
              <td style="width: 10%">
                <Button
                  @click="downloadByMd5(item.md5)"
                  class="modaldownloadlbutton"
                  :disabled="item.process !== '已完成'"
                  icon="md-download"
                ></Button>
              </td>
            </tr>
            <!--2-->
            <!--          <tr>-->
            <!--            <td style="width:5%;">-->
            <!--              2-->
            <!--            </td>-->
            <!--            <td style="width:20%;">-->
            <!--              2020-12-25 09:17:47-->
            <!--            </td>-->
            <!--            <td style="width:40%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">-->
            <!--              企业社会责任-慈善、志愿者活动以及社会争议优势-->
            <!--            </td>-->
            <!--            <td style="width:10%;">-->
            <!--              <div style="color:#19be6b;">-->
            <!--                <Icon type="md-checkmark" class="ani-check"/>-->
            <!--                压缩完成-->
            <!--              </div>-->
            <!--            </td>-->
            <!--            <td style="width:15%;">-->
            <!--              <div style="color: #4184f3">未下载</div>-->
            <!--            </td>-->
            <!--            <td style="width:10%;">-->
            <!--              <Button class="modaldownloadlbutton" icon="md-download"></Button>-->
            <!--            </td>-->
            <!--          </tr>-->
            <!--&lt;!&ndash;3&ndash;&gt;-->
            <!--          <tr>-->
            <!--            <td style="width:5%;">-->
            <!--              3-->
            <!--            </td>-->
            <!--            <td style="width:20%;">-->
            <!--              2020-12-25 09:17:48-->
            <!--            </td>-->
            <!--            <td style="width:40%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">-->
            <!--              企业社会责任-慈善、志愿者活动以及社会争议优势-->
            <!--            </td>-->
            <!--            <td style="width:10%;">-->
            <!--              <div style="color:#19be6b;">-->
            <!--                <Icon type="md-checkmark" class="ani-check"/>-->
            <!--                压缩完成-->
            <!--              </div>-->
            <!--            </td>-->
            <!--            <td style="width:15%;">-->
            <!--              <div style="color: #19be6b">已下载</div>-->
            <!--            </td>-->
            <!--            <td style="width:10%;">-->
            <!--              <Button class="modaldownloadlbutton" icon="md-download"></Button>-->
            <!--            </td>-->
            <!--          </tr>-->
          </tbody>
        </table>
      </div>
      <div slot="footer">
        <Alert
          show-icon
          style="height: 34px; display: inline-block; float: left; margin: 0px"
        >
          <Icon
            type="ios-information-circle-outline"
            slot="icon"
            style="margin-top: 2px"
          ></Icon>
          退出登录下载记录将会被清空
        </Alert>
        <button
          type="button"
          @click="cancel"
          class="ivu-btn ivu-btn-primary"
          style="width: 75px; height: 32px"
        >
          <span>关闭</span>
        </button>
      </div>
    </Modal>
    <Modal v-model="SupplyDown" width="1000" class="modaldownload">
      <div slot="header" class="modaldownload_header">
        <div class="modaldownload_header_inner">
          <i
            class="iconfont icon-gaiyao"
            style="
              font-size: 24px !important;
              vertical-align: middle;
              position: relative;
              top: -1px;
            "
          ></i>
          补充词频下载
        </div>
      </div>
      <div class="downloadlist_table_div scrollbars">
        <table
          class="downloadlist_table stickythead hoverline"
          cellspacing="0"
          cellpadding="0"
        >
          <thead class="downloadlist_thead">
            <tr>
              <th>序号</th>
              <th>提交时间</th>
              <th>数据库</th>
              <th>关键字</th>
              <th>完成时间</th>
              <th>下载</th>
            </tr>
          </thead>
          <tbody class="downloadlist_tbody">
            <!-- 空状态 -->
            <td
              v-show="showSupplyDownEmpty"
              colspan="6"
              style="padding-top: 66px"
              class="kzt"
            >
              <i class="iconfont icon-kongzhuangtai"></i>
              <p>当前暂无下载任务</p>
            </td>

            <tr v-for="(item, index) in SupplyKeyList" :key="index">
              <td style="width: 5%">
                {{ index + 1 }}
              </td>
              <td>
                {{ item.startTime }}
              </td>
              <td>
                {{ item.condition }}
              </td>
              <td>
                {{ item.keys }}
              </td>
              <td v-show="item.endTime == ''">未完成</td>
              <td v-show="item.endTime != ''">
                {{ item.endTime }}
              </td>
              <td>
                <Button
                  @click="downloadByOSSName(item.OSSName)"
                  :disabled="item.endTime === ''"
                  >下载</Button
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div slot="footer">
        <Button
          class="ivu-btn ivu-btn-primary"
          @click="SupplyDownClose"
          style="width: 75px; height: 32px"
          >关闭</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
// import VueResource from 'vue-resource'
import Bus from "../bus.js";
import axios from "@/api/axios";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import store from "../store/index";

export default {
  name: "layout",
  data() {
    return {
      dialogVisible: false,
      modalaboutUs: false,
      modaldownloadList: false,
      residueTime: 3,
      intervalId: 0,
      roleId: "",
      downloadMenuStatue: false,
      downIntervalId: 0,
      oneSelectOutHtml: "",
      modelFlag: 0,
      modelName: "",
      realtimeFlag: true,
      dataBase: [],
      model11: "",
      model12: [],
      system: [],
      downloadHistory: [],
      downloadHistoryProcess: [],
      showHistoryTr: true,
      SupplyDown: false,
      showSupplyDownEmpty: true,
      SupplyKeyList: [],
      visible: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    getSortList: function () {
      return this.downloadHistoryProcess.sort(function (a, b) {
        return a.start > b.start ? -1 : 1;
      });
    },
  },
  mounted: function () {
    axios
      .get(
        "/api/user/getTrialAccount?userName=" +
          this.$store.state.userInfo.UserName
      )
      .then((response) => {
        //console.log(response)
        if (response.data.status) {
          store.commit("setTrialAccount", true);
        } else {
          store.commit("setTrialAccount", false);
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    this.getSystemList().then((s) => {
      // 删除数据中的文本序号
      /*for(let key in s.data.SystemList){
        for (let subKey in s.data.SystemList[key]["tableInfo"]) {
          s.data.SystemList[key]["tableInfo"][subKey]["fields"].forEach((items, index) =>{
            if (items.key === "Dnumber") {
              s.data.SystemList[key]["tableInfo"][subKey]["fields"].splice(index, 1)
            }
          })
        }
      }*/
      this.SET_SYSTEMLIST(s.data.SystemList);
      this.getDatabaseList();
    });
    Bus.$on("showSupplyDown", (item) => {
      this.showSupplyDown();
    });
    var userRoleId = 0;
    this.submitForm();
    $("#MsgBoardIframe").on("load", (e) => {
      $("#closeContactUsModalBtn").click();
      var responseTetx = $(e.currentTarget)[0].contentDocument.body.textContent;
      var responseJsonObj = JSON.parse(responseTetx);
      var zuiMassage;
      if (responseJsonObj.status == true) {
        this.$Message.info("您的信息已成功提交！");
      } else {
        this.$Message.info("提交失败，请重试!");
      }
    });
    $("video").bind("contextmenu", function () {
      return false;
    });
    // $("#topCloudDiv").css({
    //     "-webkit-animation":"topCloudMove 30s infinite linear",
    //     "animation":"topCloudMove 30s infinite linear",
    //     "-moz-animation":"topCloudMove 30s infinite linear",
    //     "-o-animation":"topCloudMove 30s infinite linear",
    //     "-ms-animation":"topCloudMove 30s infinite linear"
    // });

    $(document).keyup((event) => {
      var downListStatue = $(".downLoadQueue_div").css("display");
      if (downListStatue == "block") {
        var keyCode = event.keyCode;
        if (keyCode == 27 || keyCode == 96) {
          this.showDownLoadMenuList();
        }
      }
    });
    if (window.location.href.indexOf("?contact=1") > -1) {
      $("#contactusbtn").click();
    }
    if (window.location.href.indexOf("?about=1") > -1) {
      $("#aboutusbtn").click();
    }
  },
  watch: {
    downloadMenuStatue: {
      handler: function (val, oldVal) {
        if (val == true) {
          this.hideDownLoadMenu();
        }
      },
      deep: true,
    },
  },
  updated: function () {
    this.publicMoveBottomBg();
    // $("#topCloudDiv").css({
    //     "animation":"topCloudMove 30s infinite linear",
    //     "-webkit-animation":"topCloudMove 30s infinite linear",
    //     "-moz-animation":"topCloudMove 30s infinite linear",
    //     "-o-animation":"topCloudMove 30s infinite linear",
    //     "-ms-animation":"topCloudMove 30s infinite linear"
    // });
  },
  methods: {
    DownLoadClient() {
      window.open(
        "https://jinghe-picture.oss-cn-shanghai.aliyuncs.com/aitextclient%2F%E7%88%B1%E6%96%87%E6%9C%AC%E5%AE%A2%E6%88%B7%E7%AB%AF1.0.81Setup.exe"
      );
      this.modalDownload = false;
    },
    playVideo() {
      // this.dialogVisible = true;
      // setTimeout(() => {
      //   $('video').bind('contextmenu',function() { return false; });
      // }, 100)
      this.$router.push({ name: "operateVideo" });
    },
    ...mapGetters(["getMD5List"]),
    ...mapActions(["signOut", "getSystemList"]),
    ...mapMutations(["SET_USER_SIGNOUT", "SET_SYSTEMLIST", "SET_ISDOWNLOAD"]),
    Personal_Center() {
      this.$router.push({ name: "personalCenter" });
    },
    // showSupplyDown() {
    //   //debugger
    //   axios.get('/api/showSupplyDownList')
    //       .then(response => {
    //         if (response.data.data.length > 0) {
    //           this.showSupplyDownEmpty = false;
    //           let list = [];
    //           response.data.data.forEach((item) => {
    //             list.push({
    //               condition: item.condition,
    //               startTime: item.startTime,
    //               endTime: item.endTime,
    //               keys: item.keys,
    //               OSSName: item.OSSName
    //             })
    //           })
    //           this.SupplyKeyList = list;
    //         }
    //       })
    //   this.SupplyDown = true;
    // },
    showHistoryModel() {
      console.log("333333333");
      this.showModaldownloadList();
    },
    showModaldownloadList() {
      this.downloadHistoryProcess = [];
      this.modaldownloadList = true;
      this.downloadHistory = this.$store.getters.getMD5List;
      if (this.downloadHistory.length === 0) {
        return;
      } else {
        this.showHistoryTr = false;
      }
      let tempList = [];
      this.downloadHistory.forEach((item) => {
        axios
          .post("/api/getDownloadResult", {
            md5: item.md5,
          })
          .then((res) => {
            if (res.data.data.process === "finish") {
              tempList.push({
                start: item.start_time,
                md5: res.data.data.taskMD5,
                process: "已完成",
                percentage: 100,
                condition: res.data.data.condition,
                isDownload: item.isDownload,
              });
            } else {
              let p;
              switch (res.data.data.process) {
                case "submit":
                  p = "已提交";
                  break;
                case "Transformation":
                  p = "转换中";
                  break;
                case "FileGenerated":
                  p = "压缩中";
                  break;
                default:
                  p = "正在处理";
                  break;
              }
              tempList.push({
                start: item.start_time,
                md5: res.data.data.taskMD5,
                process: p,
                percentage: res.data.data.percentage,
                condition: res.data.data.condition,
                isDownload: item.isDownload,
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
      this.downloadHistoryProcess = tempList;
    },
    downloadByMd5(md5) {
      this.SET_ISDOWNLOAD(md5);
      this.showModaldownloadList();
      axios
        .post("/api/getDownloadUrl", { md5: md5 })
        .then((response) => {
          var a = document.createElement("a");
          a.href = response.data.data;
          a.click();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    downloadByOSSName(OSSName) {
      //debugger
      axios.post("/api/getDownloadKeyUrl", { OSSName: OSSName }).then((res) => {
        var a = document.createElement("a");
        a.href = res.data.data;
        a.click();
      });
    },

    //获取当前数据库配置信息，只有数据库有的模块才显示
    goToPathAndTop(params) {
      this.$router.push(params);
      document.getElementsByClassName("scrollbar")[0].scrollTop = 0;
    },

    clearBackDrop: function () {
      $("#backDropDiv").css("display", "none");
    },
    deleteFlagCookie: async function () {
      await this.signOut();
      this.SET_USER_SIGNOUT();
      this.$store.state.taskMD5List = [];
      window.sessionStorage.removeItem("store");
      this.$router.push("/");
      $.cookie("modalFlag", "", { expires: -1 });
      $.cookie("remindAuth", null);
    },
    hideDownLoadMenu: function () {
      $(document).bind("click", function (e) {
        var target = $(e.target);
        if (
          target.closest(".middle_ul li").length == 0 &&
          target.closest(".contact_ul li").length == 0 &&
          target.closest(".downLoadQueue_div").length == 0
        ) {
          $(".downLoadQueue_div").fadeOut(300);
        }
      });
    },
    showDownLoadMenuList: function () {
      var displayStatue = $(".downLoadQueue_div").css("display");
      if (displayStatue == "none") {
        $(".downLoadQueue_div").fadeIn(300);
        this.downloadMenuStatue = true;
      } else {
        $(".downLoadQueue_div").fadeOut(300);
        this.downloadMenuStatue = false;
      }
    },
    submitForm: function () {
      var vaildatorRule = {
        message: "This value is not valid",
        feedbackIcons: {
          valid: "glyphicon glyphicon-ok",
          invalid: "glyphicon glyphicon-remove",
          validating: "glyphicon glyphicon-refresh",
        },
        fields: {
          name: {
            message: "The username is not valid",
            validators: {
              notEmpty: {
                message: "请输入您的称呼",
              },
            },
          },
          email: {
            validators: {
              notEmpty: {
                message: "请输入您的email地址",
              },
              emailAddress: {
                message: "不符合email地址规则",
              },
            },
          },
          school: {
            validators: {
              notEmpty: {
                message: "请输入您的学校",
              },
            },
          },
          phone: {
            validators: {
              notEmpty: {
                message: "请输入您的联系电话",
              },
              stringLength: {
                max: 11,
                message: "电话长度必须为11位",
              },
              regexp: {
                regexp: /^1(3|4|5|6|7|8|9)\d{9}$/,
                message: "电话格式不正确，如：【17821816737】",
              },
            },
          },
          message: {
            validators: {
              notEmpty: {
                message: "请输入您的留言信息",
              },
            },
          },
        },
      };
      $("#submitAdviceForm").bootstrapValidator(vaildatorRule);
    },

    publicMoveBottomBg: function () {
      var localUrl = window.location.href;
      var leftValue;
      if (localUrl.indexOf("index") >= 0) {
        leftValue = 9;
      } else if (localUrl.indexOf("gsgg") >= 0) {
        leftValue = 9;
      } else if (localUrl.indexOf("xwbd") >= 0) {
        leftValue = 138;
      } else if (localUrl.indexOf("yjbg") >= 0) {
        leftValue = 268;
      } else if (localUrl.indexOf("gsjg") >= 0) {
        leftValue = 398;
      } else if (localUrl.indexOf("qtwb") >= 0) {
        leftValue = 528;
      } else if (localUrl.indexOf("personalCenter") >= 0) {
        leftValue = 11111;
      }

      $(".navigation_bottom_color_div").animate(
        {
          left: leftValue + "px",
        },
        300
      );
    },
    toDatabase(value) {
      this.$router.push({
        path: "/views/" + value + "/analysis",
      });
    },
    // TODO 已下架的库需排除
    getDatabaseList() {
      this.system = this.$store.state.SystemList;
      for (var key in this.system) {
        var item = this.system[key];
        this.dataBase.push({
          value: item.module + "/" + item.prefixName,
          label: item.name,
        });
      }
    },
    cancel() {
      this.modaldownloadList = false;
    },
    SupplyDownClose() {
      this.SupplyDown = false;
    },
    handleOpen() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
:deep(.el-dialog) {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
}

:deep(.el-dialog__headerbtn .el-dialog__close) {
  color: white;
}

html,
body {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  background-color: #689edb;
}

.ul_class li {
  list-sytle-type: none;
  height: 40px;
}

.ul_class {
  width: auto;
  height: auto;
  padding-top: 2px;
  padding-bottom: 6px;
  padding-left: 0px;
  text-align: center;
}

.ul_class li a {
  text-decoration: none;
  color: white;
  font-weight: lighter;
}

.ul_class .chat_info {
  color: black;
  font-weight: lighter;
  width: 100%;
  font-size: 12px;
  margin-top: 20px;
  margin-bottom: 10px;
  background: #e0ffff;
  text-align: left;
  height: 130px;
}

.left_div {
  font-size: 16px;
  height: 100%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 10%;
}

.bottom_div {
  height: 100%;
  margin-bottom: 5px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-top: 0px;
}

.ul_class .chat_div {
  font-size: 15px;
  padding-top: 16px;
  padding-left: 20px;
}

.li_img {
  color: white;
}

.head_top {
  height: 64px;
  width: 100%;
  background-color: #1c48a6;
  position: relative;
}

.head_top_content {
  position: relative;
  width: 1440px;
  margin: 0px auto;
  line-height: 64px;
  height: 64px;
}

.head_top_left {
  position: absolute;
  left: 0;
}

.head_top_right {
  position: absolute;
  right: 0;
}

.head_top_item {
  color: #fff;
  display: inline-block;
  margin-right: 16px;
  height: 64px;
  float: left;
}

.head_top_item a {
  color: #fff;
}

.head_top_line {
  float: left;
  height: 16px;
  border-left: 1px solid #7b95cb;
  margin-top: 26px;
  margin-right: 16px;
}

.item_downloadlist {
  cursor: pointer;
  position: relative;
}

.item_downloadlist i {
  font-size: 22px;
  display: inline;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  line-height: 64px;
  border: 8px solid transparent;
  position: relative;
  top: 2px;
  margin-right: -8px;
}

.item_downloadlist i:hover {
  background: #174097;
  transition: 0.4s;
  border: 8px solid #174097;
}

.userInfo {
  float: right;
  position: relative;
  margin: 0 auto;
  right: 30px;
}

.userInfo div {
  float: left;
  text-align: left;
  color: #fff;
  line-height: 25px;
  font-size: 12px;
}

.help {
  width: 50px;
  float: left;
  text-align: left;
  color: #fff;
  line-height: 25px;
  font-size: 12px;
}

.home_page {
  width: 50px;
  float: left;
  text-align: left;
  color: #fff;
  line-height: 25px;
  font-size: 12px;
}

.head_center {
  width: 100%;
  height: 50px;
  background: #fafafa;
  position: relative;
  box-shadow: inset 0px -1px 0px #e2e2ea;
}

.head_center_body_div {
  height: 50px;
  margin: 0 auto;
  padding: 0px 15px;
}

.img_div {
  float: left;
  height: 85px;
  text-align: center;
  font-size: 20px;
  padding: 0px 0px;
}

.head_center_right_div {
  height: 50px;
  float: right;
}

.center_right_top {
  width: 100%;
  height: 40px;
  padding-top: 10px;
}

.center_right_top .form-control {
  border-radius: 0px;
  height: 30px;
  float: left;
  border-color: rgba(255, 255, 255, 0.45);
  background: transparent;
  background-color: transparent;
  padding-right: 40px;
  color: #000;
  padding-top: 0;
  padding-bottom: 0;
}

.center_right_top .form-control:focus {
  background-color: rgba(255, 255, 255, 0.45);
}

.bi-search {
  color: rgb(145, 199, 241);
  font-size: 20px;
  position: absolute;
  right: 10px;
  top: 6px;
}

.interSearchDetail_span {
  font-size: 12px;
  position: absolute;
  right: 15px;
  line-height: 30px;
  cursor: pointer;
  color: rgb(48, 118, 188);
  display: none;
}

.right_div {
  /* height: 100%;*/
  width: 100%;
  background: #fff;
  margin-right: 5px;
}

.right_left_div {
  height: 100%;
  width: 25%;
  border: 1px solid rgba(255, 255, 255, 0.4);
  overflow: scroll;
  position: relative;
  background-color: white;
}

.right__right_div {
  height: 100%;
  width: 75%;
  background-color: white;
  overflow: scroll;
}

.middle_menu_ul {
  padding-left: 2px;
  height: 100%;
}

.middle_menu_li_1 {
  margin: 8px;
  list-style: none;
  list-style-type: none;
  border: 1px solid black;
  height: 120px;
}

/* h4 {
    margin-left: 7px
} */

.middle_menu_li_1 li {
  list-style: none;
  list-style-type: none;
  width: 50%;
  float: left;
}

.middle_menu_li_1 li a {
  text-align: center;
  font-size: 15px;
  font-weight: lighter;
  color: black;
  text-decoration: none;
}

/* .bottom_div div {
    margin: 0 auto;
} */

.checkCondition_div {
  margin-top: 10px;
  margin-left: 50px;
}

.loves_check {
  width: 100%;
  display: none;
}

.year_check {
  width: 100%;
  display: none;
}

.field_check {
  width: 100%;
  display: none;
}

.serach_check {
  width: 100%;
  display: none;
}

.download_check {
  width: 100%;
  display: none;
}

.timerange_check {
  width: 100%;
  display: none;
}

.newsvalue_check {
  width: 100%;
  display: none;
}

.instrument_check {
  width: 100%;
  display: none;
}

.newsvalue1_check {
  width: 100%;
  display: none;
}

.guba_check {
  width: 100%;
  display: none;
}

.par_div {
  width: 80%;
  height: 50px;
  font-size: 18px;
  color: black;
  line-height: 50px;
}

.serach_input {
  width: 100%;
  height: 50px;
  margin-top: 5px;
  color: black;
}

.radio_class {
  width: 20px;
  height: 20px;
}

.radio_div {
  float: right;
}

.btn.btn-default {
  background-color: rgba(255, 255, 255, 0);
  border: hidden;
  width: 100%;
  height: 50px;
  text-align: center;
  color: black;
  font-size: 16px;
  text-align: left;
  margin: 0;
  padding: 0;
}

.checkbox_left {
  font-size: 16px;
  height: 50px;
  margin-left: 30px;
  float: left;
}

.checkbox_right {
  font-size: 16px;
  height: 50px;
  margin-left: 30px;
  float: right;
}

.check_span {
  line-height: 50px;
  height: 100%;
}

.cus_div {
  height: 70px;
  width: 100%;
  margin-bottom: 5px;
}

.cus_top {
  height: 50%;
  width: 100%;
  font-size: 18px;
  color: black;
}

.cus_bottom {
  height: 50%;
  width: 100%;
  font-size: 18px;
  color: black;
}

#customRange_div {
  margin-bottom: 5px;
}

.headImg_div {
  float: left;
  margin-top: 20px;
  position: absolute;
  margin-left: 423px;
  /* background: url('/img/login/wenben/link.png') no-repeat; */
  height: 60px;
  width: 400px;
}

.downLoadQueue_div {
  position: absolute;
  width: 450px;
  height: 400px;
  right: 10px;
  top: 50px;
  z-index: 110;
  display: none;
}

.down_bottom {
  width: 100%;
  height: 100%;
  background-color: white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
}

.down_bottom_head_div {
  width: 100%;
  height: 45px;
  margin-bottom: 5px;
}

.bottonbg_div {
  height: 45px;
  width: 120px;
  background-color: rgba(39, 119, 184, 0.8);
  position: absolute;
  margin-top: 10px;
  margin-left: 10px;
  border-radius: 5px;
}

.downLoad_list_div {
  position: relative;
  height: 45px;
  width: 120px;
  float: left;
  cursor: pointer;
  text-align: center;
  color: white;
  margin-top: 10px;
  margin-left: 10px;
}

.downLoad_historylist_div {
  position: relative;
  height: 45px;
  width: 120px;
  float: left;
  cursor: pointer;
  text-align: center;
  color: black;
  margin-top: 10px;
}

.down_font_span {
  line-height: 45px;
}

.downPorcess_list {
  height: 350px;
  width: 100%;
}

.downloading {
  height: 100%;
  width: 100%;
  overflow-x: auto;
}

.down_history {
  height: 100%;
  width: 100%;
  display: none;
  overflow-x: auto;
}

.netNewsUl {
  width: 200px;
  position: absolute;
  z-index: 110;
  padding: 0px;
  margin-bottom: 0px;
  top: 90px;
  left: 34%;
  display: none;
}

.netNewsUl li {
  list-style: none;
  width: 200px;
  height: 40px;
  background-color: white;
  text-align: center;
}

.newsPaperUl {
  width: 200px;
  position: absolute;
  z-index: 110;
  padding: 0px;
  margin-bottom: 0px;
  top: 90px;
  left: 41%;
  display: none;
}

.newsPaperUl li {
  list-style: none;
  width: 200px;
  height: 40px;
  background-color: white;
}

.fileToDownImg_div {
  width: 20px;
  height: 20px;
  position: fixed;
  left: 200px;
  z-index: 200;
  display: none;
}

.topMenu_div {
  height: 45px;
  margin-top: 10px;
  padding-left: 15px;
}

.font_div {
  height: 25px;
  margin-top: 10px;
  position: absolute;
  width: 100%;
}

.downSelect_forMonth_div {
  position: relative;
  height: 45px;
  width: 120px;
  float: left;
  cursor: pointer;
  text-align: center;
  color: white;
}

.downSelect_forYear_div {
  position: relative;
  height: 45px;
  width: 120px;
  float: left;
  cursor: pointer;
  text-align: center;
  color: black;
}

.downSelect_font_span {
  line-height: 45px;
}

.modal_bottonbg_div {
  margin-left: 15px;
  height: 45px;
  width: 120px;
  background-color: rgba(39, 119, 184, 0.8);
  position: absolute;
  border-radius: 5px;
}

.select_model_div {
  height: 40px;
  position: absolute;
  width: 100%;
  top: 35px;
}

.addSelect {
  height: 35px;
  border: 1px solid #67b8f1 !important;
  text-align: center;
  border-radius: 5px;
}

.addSelect:hover {
  background-color: rgba(183, 218, 239, 0.63);
  cursor: pointer;
}

.submit_forMonth {
  height: 35px;
  width: 100%;
}

.submit_forMonth button:hover {
  background-color: rgba(183, 218, 239, 0.63);
}

#oneSelect_model {
  height: 75px;
  position: relative;
}

.font_prompt {
  font-size: 14px;
  color: red;
  line-height: 35px;
  float: left;
}

#downLoatSelectModel {
  top: 25%;
}

.navigation {
  width: 100%;
  height: 50px;
  text-align: center;
  font-weight: 700;
}

.navigation_bottom_color_div {
  height: 10px;
  width: 90px;
  position: absolute;
  border-top: 10px solid #4184f3;
  margin: 0px 12px;
  border-radius: 4px 4px 0px 0px;
  bottom: -7.2px;
  left: 9px;
}

.navigation_menu {
  position: relative;
  width: 796px;
  height: 50px;
  font-size: 16px;
  color: white;
  margin: 0px auto;
  overflow: hidden;
}

.oneNavItem_div h4 {
  line-height: 50px;
  font-weight: 500;
  font-size: 15px;
}

.oneNavItem_div i {
  margin-right: 5px;
  color: #92929d;
  position: relative;
  top: 1px;
}

.oneNavItem_div {
  height: 100%;
  width: 130px;
  float: left;
  line-height: 50px;
  cursor: pointer;
  z-index: 10;
  position: relative;
}

.oneNavItem_div:hover {
  background-color: #99999916;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.router-link-active .oneNavItem_div h4 {
  color: #4184f3;
}

.router-link-active .oneNavItem_div i {
  color: #4184f3;
}

#comment-form-author::before {
  content: "\F3FC";
  color: #4184f3;
  position: absolute;
  font-family: Ionicons;
  padding-left: 8px;
  height: 54px;
  line-height: 90px;
}

#comment-form-phone::before {
  content: "\F15E";
  color: #4184f3;
  position: absolute;
  font-family: Ionicons;
  padding-left: 8px;
  height: 54px;
  line-height: 90px;
}

#comment-form-school::before {
  content: "\F254";
  color: #4184f3;
  position: absolute;
  font-family: Ionicons;
  padding-left: 8px;
  height: 54px;
  line-height: 90px;
}

#comment-form-email::before {
  content: "\F221";
  color: #4184f3;
  position: absolute;
  font-family: Ionicons;
  padding-left: 8px;
  height: 54px;
  line-height: 90px;
}

@media (min-width: 1560px) {
  .head_center_body_div {
    width: 1260px;
  }

  .userInfo {
    float: right;
    position: relative;
    right: 30px;
  }

  .head_left_div {
    width: 1260px;
    padding-right: 15px;
  }

  .head_top_content {
    width: 1440px;
  }
}

@media (min-width: 1420px) and (max-width: 1560px) {
  .head_top_content {
    width: 1180px;
  }
}

@media (max-width: 1420px) {
  .userInfo {
    float: right;
    position: relative;
    right: 30px;
  }

  .headImg_div {
    /* background: url('/img/login/link.png') no-repeat; */
    width: 336px;
    margin-top: 25px;
    margin-left: 20px;
  }

  .middle_ul {
    margin-left: 24%;
  }

  .netNewsUl {
    left: 30%;
  }

  .newsPaperUl {
    left: 39%;
  }

  #downLoatSelectModel {
    top: 15% !important;
  }

  .head_top_content {
    width: 1180px;
  }
}

@media (max-width: 1220px) {
  .headImg_div {
    /* background: url('/img/login/link.png') no-repeat; */
    width: 270px;
    margin-top: 30px;
    margin-left: 10px;
  }

  .middle_ul {
    margin-left: 22%;
  }

  .netNewsUl {
    left: 28%;
  }

  .newsPaperUl {
    left: 39%;
  }

  .head_top_content {
    width: 960px;
  }
}

@media (max-width: 1024px) {
  .netNewsUl {
    left: 30%;
  }

  .newsPaperUl {
    left: 41%;
  }

  .head_top_content {
  }
}

@media (max-width: 1000px) {
  .headImg_div {
    /* background: url('/img/login/link.png') no-repeat; */
    width: 0px;
    height: 0px;
  }

  .middle_ul {
    margin-left: 15%;
  }

  .netNewsUl {
    left: 22%;
  }

  .newsPaperUl {
    left: 36%;
  }

  .head_top_content {
  }
}

/* contact modal */
.contact .modal-header {
  border-bottom: none;
  padding-bottom: 0px;
}

.contact .modal-body label {
  font-size: 80%;
  font-weight: 400;
  color: #b0b0b0;
}

.contact .modal-body p {
  color: #5a5a5a;
  font-weight: 400;
}

#comment-form-author {
  margin-top: 10px;
}

#contactbtn {
  margin-bottom: 15px;
  text-align: center;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  border-radius: 2px;
}

#contactbtn:hover {
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
  box-shadow: none;
}

#contactbtn:focus {
  background: #248ffa;
  border-color: #248ffa;
  color: #fff;
  outline: none;
}

.contact .modal-body img {
  float: right;
  position: relative;
  top: -100px;
  right: 4px;
}

.contactinf {
}

.contactinf h4 {
  color: #303030;
  margin: 15px 0px;
  margin-top: 20px;
}

.contactinf p {
  font-size: 78%;
  margin: 0 0 10px;
}

.contact .contacttxt p {
  color: #272727;
  font-size: 90%;
}

@media (min-width: 1560px) {
  .head_center_body_div {
    width: 1500px;
  }

  .head_left_div {
    width: 1500px;
  }
}

@media (min-width: 1420px) {
  @media (max-width: 1560px) {
    .head_center_body_div {
      width: 1260px;
    }

    .head_left_div {
      width: 1260px;
    }
  }
}

@media (min-width: 1200px) {
  @media (max-width: 1420px) {
    .head_center_body_div {
      width: 1160px;
    }

    .head_left_div {
      width: 1160px;
    }
  }
}

@media (min-width: 1000px) {
  @media (max-width: 1200px) {
    .head_center_body_div {
      width: 1040px;
    }

    .head_left_div {
      width: 1010px;
    }
  }
}

@media (max-width: 1000px) {
  .head_center_body_div {
    width: 920px;
  }

  .head_left_div {
    width: 900px;
  }
}

.dbselect /deep/ .ivu-icon-md-search {
  color: #a2b3d5;
  position: relative;
  font-size: 15px;
  top: 2px;
  left: 7px;
}

.dbselect /deep/ .ivu-select-selection {
  opacity: 0.9;
  border: 1px solid #174097;
  background: #174097;
}

.dbselect /deep/ .ivu-select-selection:hover {
  opacity: 1;
  background-color: #174097;
}

.dbselect /deep/ .ivu-select-input {
  color: #a2b3d5;
  padding-left: 16px;
  width: 262px;
}

.dbselect /deep/ input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #a2b3d5;
}

.dbselect /deep/ input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #a2b3d5;
}

.dbselect /deep/ input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #a2b3d5;
}

.dbselect /deep/ .ivu-select-dropdown {
  z-index: 1000;
}

.dbselect /deep/ .ivu-select-dropdown::-webkit-scrollbar {
  width: 5px;
}

.dbselect /deep/ .ivu-select-dropdown::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.25);
}

.dbselect /deep/ .ivu-select-dropdown::-webkit-scrollbar-track {
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.1);
}

.footertop {
  background-color: #0b0d17;
  padding-bottom: 30px;
  padding-top: 80px;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.3;
}

@media (min-width: 1560px) {
  .container {
    width: 1440px;
  }
}

@media (min-width: 1420px) {
  @media (max-width: 1560px) {
    .container {
      width: 1300px;
    }
  }
}

@media (min-width: 1220px) {
  @media (max-width: 1420px) {
    .head_left_div {
      width: 1126px;
    }
  }
}

@media (min-width: 1000px) {
  @media (max-width: 1220px) {
    .single-widget img {
      display: none;
    }

    .footertop {
      padding-bottom: 15px;
      padding-top: 35px;
      padding-left: 100px;
    }

    #footerlogo {
      display: none;
    }
  }
}

@media (max-width: 1000px) {
}

.single-widget {
  margin-bottom: 30px;
}

.single-widget img {
  width: 230px;
  height: 230px;
  position: relative;
  top: -80px;
  left: 20px;
}

.single-widget h3 {
  color: #ccc;
  border-bottom: 1px solid rgba(233, 233, 233, 0.1);
  margin-bottom: 30px;
  padding-bottom: 10px;
  font-size: 20px;
  font-weight: 600;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.single-widget .additional-link li {
  color: #ccc;
  font-family: "Open Sans", sans-serif;
  margin-bottom: 20px;
}

.single-widget .additional-link li a {
  display: block;
  color: #ccc;
  position: relative;
  padding-left: 20px;
}

.single-widget .additional-link li a:hover {
  color: white;
}

.single-widget .additional-link li a::before {
  content: "";
  position: absolute;
  top: 9px;
  left: 0;
  width: 5px;
  height: 5px;
  background-color: #ccc;
}

.single-widget .additional-link li a:hover::before {
  background-color: white;
}

.single-widget .address li {
  color: #ccc;
  margin-bottom: 20px;
}

.single-widget .address li i {
  font-size: 20px;
  margin-right: 12px;
  color: #e0e0e0;
  position: relative;
  top: 2px;
}

.aitexts-footer {
  display: flex;
  align-items: center;
  height: 80px;
  background: #0b0d17;
  justify-content: center;
  font-size: 12px;
  flex: 0 0 auto;
  z-index: 10;
  border-top: 1px solid rgba(233, 233, 233, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, segoe ui, Roboto,
    helvetica neue, Arial, noto sans, sans-serif, apple color emoji,
    segoe ui emoji, segoe ui symbol, noto color emoji;
}

.content-wh {
  /* width: 70%; */
  min-width: 1300px;
}

.aitexts-footer,
.aitexts-footer .footer-el {
  display: flex;
  align-items: center;
}

.aitexts-footer .footer-el .footer-addr {
  flex: 1;
  color: #ccc;
}

.aitexts-footer .footer-el .footer-addr .addr {
  line-height: 25px;
  text-align: center;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, segoe ui, Roboto,
    helvetica neue, Arial, noto sans, sans-serif, apple color emoji,
    segoe ui emoji, segoe ui symbol, noto color emoji;
}

.aitexts-footer .footer-el .footer-logo img {
  width: 100px;
}

.aitexts-footer .footer-el .footer-code img {
  height: 90px;
}

/* 关于我们模态框 Start */
.modalaboutus /deep/ .ivu-modal-close {
  z-index: 30000;
  margin-right: 25px;
}

.modalaboutus /deep/ .ivu-icon-ios-close {
  font-size: 45px;
}

.modalaboutus /deep/ .ivu-modal-content {
  z-index: 1031;
}

.modalaboutus /deep/ .ivu-modal-body {
  padding: 0px;
  background-color: #0f0f0e;
}

.modalaboutus /deep/ .ivu-modal-body::-webkit-scrollbar {
  width: 5px;
}

.modalaboutus /deep/ .ivu-modal-body::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.25);
}

.modalaboutus /deep/ .ivu-modal-body::-webkit-scrollbar-track {
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.1);
}

.modalaboutus /deep/ .container {
  width: 1410px;
  padding: 0 15px;
}

.fixed-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: -1;
}

.bg1 {
  background-image: url("/img/login/gai2.png ");
  filter: brightness(0.3);
  background-color: #0f0f0e;
}

.block {
  padding: 170px 0;
}

.section-title {
  position: relative;
  margin-bottom: 83px;
  margin-top: -50px;
}

.section-title .h-title {
  color: #fff;
  font-size: 68px;
  font-weight: 700;
  line-height: 80px;
  max-width: 500px;
  font-family: "Cinzel", serif;
  animation: fromtopTobottom 0.9s;
  -webkit-animation: fromtopTobottom 0.9s;
  /* Safari and Chrome */
  -moz-animation: fromtopTobottom 0.9s;
  /* Firefox */
  -o-animation: fromtopTobottom 0.9s;
  /* Opera */
  position: relative;
  margin-top: 15px;
}

.overlay {
  position: relative;
  z-index: 9;
}

.overlay:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #262626;
  z-index: -1;
  opacity: 0.85;
}

.services .service-col {
  animation: fromleftToright 0.9s;
  -webkit-animation: fromleftToright 0.9s;
  /* Safari and Chrome */
  -moz-animation: fromleftToright 0.9s;
  /* Firefox */
  -o-animation: fromleftToright 0.9s;
  /* Opera */
  position: relative;
  padding-left: 5px;
}

.services .service-col h2 {
  color: #fff;
  font-size: 56px;
  font-weight: 400;
  font-family: "Cinzel", serif;
  margin-bottom: 4px;
}

.services .service-col h2 span {
  color: #f43930;
}

.services .service-col h4 {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 11px;
}

.services .service-col p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 15px;
  font-weight: 500;
  line-height: 19px;
}

.smpl-txt {
  background-color: rgba(37, 37, 37, 0.7);
  border: 1px solid #6e6e6e;
  padding: 63px 88px 47px;
  margin-top: -225px;
  margin-bottom: 55px;
  animation: fromrightToleft 0.9s;
  -webkit-animation: fromrightToleft 0.9s;
  /* Safari and Chrome */
  -moz-animation: fromrightToleft 0.9s;
  /* Firefox */
  -o-animation: fromrightToleft 0.9s;
  /* Opera */
  position: relative;
}

.smpl-txt h4 {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 23px;
}

.smpl-txt p {
  color: rgba(255, 255, 255, 0.4);
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 15px;
}

@keyframes fromtopTobottom {
  0% {
    top: -30px;
  }

  100% {
    top: 0px;
  }
}

@-moz-keyframes fromtopTobottom

/* Firefox */ {
  0% {
    top: -30px;
  }

  100% {
    top: 0px;
  }
}

@-webkit-keyframes fromtopTobottom

/* Safari and Chrome */ {
  0% {
    top: -30px;
  }

  100% {
    top: 0px;
  }
}

@-o-keyframes fromtopTobottom

/* Opera */ {
  0% {
    top: -30px;
  }

  100% {
    top: 0px;
  }
}

@keyframes fromrightToleft {
  0% {
    right: -30px;
  }

  100% {
    right: 0px;
  }
}

@-moz-keyframes fromrightToleft

/* Firefox */ {
  0% {
    right: -30px;
  }

  100% {
    right: 0px;
  }
}

@-webkit-keyframes fromrightToleft

/* Safari and Chrome */ {
  0% {
    right: -30px;
  }

  100% {
    right: 0px;
  }
}

@-o-keyframes fromrightToleft

/* Opera */ {
  0% {
    right: -30px;
  }

  100% {
    right: 0px;
  }
}

@keyframes fromleftToright {
  0% {
    left: -30px;
  }

  100% {
    left: 0px;
  }
}

@-moz-keyframes fromleftToright

/* Firefox */ {
  0% {
    left: -30px;
  }

  100% {
    left: 0px;
  }
}

@-webkit-keyframes fromleftToright

/* Safari and Chrome */ {
  0% {
    left: -30px;
  }

  100% {
    left: 0px;
  }
}

@-o-keyframes fromleftToright

/* Opera */ {
  0% {
    left: -30px;
  }

  100% {
    left: 0px;
  }
}

/*关于我们模态框 End */

/* 下载列表模态框 Start */
.modaldownload /deep/ .ivu-icon-ios-close {
  color: rgb(71, 115, 187);
  opacity: 0.7;
}

.modaldownload_header {
  border-bottom: none !important;
  padding-bottom: 0px;
}

.modaldownload_header_inner {
  display: inline-block;
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: rgb(71, 115, 187);
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.downloadlist_table_div {
  overflow: auto;
  height: 333px;
  border: 1px solid rgba(223, 229, 240, 0.8);
  border-radius: 2px;
}

.downloadlist_table {
  width: 100%;
}

.downloadlist_thead th {
  white-space: nowrap;
  padding: 0 10px;
  height: 39px;
  background: #ecf2fe;
}

.downloadlist_tbody {
  background: #fff;
  /*height: 286px;*/
}

.downloadlist_tbody tr {
  height: 28px;
  text-align: center;
  border-bottom: 1px solid rgba(223, 229, 240, 0.8);
}

.downloadlist_tbody td {
  white-space: nowrap;
  padding: 0 10px;
}

.downloadlist_table td,
.downloadlist_table th {
  padding: 6px 20px;
  text-align: center;
  color: #515a6e;
  vertical-align: middle;
  z-index: 2;
}

.modaldownload /deep/ .ivu-modal-footer {
  border-top: none;
  padding: 0px 18px 12px 18px;
}

.modaldownloadlbutton {
  border: none;
  color: #4184f3;
  text-align: center;
}

.modaldownloadlbutton:focus {
  outline: none;
  box-shadow: none;
}

.modaldownload /deep/ .ivu-btn[disabled] {
  background: none;
  color: #c5c8ce !important;
}

.modaldownload /deep/ .ivu-icon-md-download {
  position: relative;
  left: 1px;
  font-size: 18px;
}

.ani-loading {
  animation: loading 1s cubic-bezier(0.48, 0.62, 1, 1) infinite;
  color: #4184f3;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(1turn);
  }
}

@-moz-keyframes loading

/* Firefox */ {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(1turn);
  }
}

@-webkit-keyframes loading

/* Safari and Chrome */ {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(1turn);
  }
}

@-o-keyframes loading

/* Opera */ {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(1turn);
  }
}

.ani-check {
  color: #19be6b;
  animation: check 1s cubic-bezier(0.83, 0, 0.17, 1);
}

@keyframes check {
  0% {
    clip-path: inset(0 100% 0 0);
  }

  100% {
    clip-path: inset(0 0% 0 0);
  }
}

@-moz-keyframes check

/* Firefox */ {
  0% {
    clip-path: inset(0 100% 0 0);
  }

  100% {
    clip-path: inset(0 0% 0 0);
  }
}

@-webkit-keyframes check

/* Safari and Chrome */ {
  0% {
    clip-path: inset(0 100% 0 0);
  }

  100% {
    clip-path: inset(0 0% 0 0);
  }
}

@-o-keyframes check

/* Opera */ {
  0% {
    clip-path: inset(0 100% 0 0);
  }

  100% {
    clip-path: inset(0 0% 0 0);
  }
}

/* 下载列表模态框 End */

/* 滚动条 */
.scrollbars::-webkit-scrollbar {
  width: 8px;
}

.scrollbars::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.2);
}

.scrollbars::-webkit-scrollbar-track {
  border-radius: 0px;
  background: rgba(0, 0, 0, 0.1);
}

.icon-kongzhuangtai {
  font-size: 66px;
  padiing-top: 50px;
}

.kzt {
  opacity: 0.5;
  color: #3c5a98 !important;
}

.ivu-alert-info {
  border: 1px solid #c4d6ff;
  background-color: #f2f6ff;
}
</style>
